import React from "react";
import { FaBell } from "react-icons/fa";

function InvoiceFollowupButton({
  onClick,
  label = "Add follow-up",
  className = "",
  disabled = false,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      className={`cms-inv-followup-btn cms-inv-followup-btn--outline inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-[12px] font-semibold text-slate-700 shadow-sm transition hover:border-[#007BFF] hover:text-[#007BFF] disabled:opacity-50 ${className}`}
    >
      <FaBell size={12} aria-hidden />
      <span>{label}</span>
    </button>
  );
}

export default InvoiceFollowupButton;
